module.exports = __webpack_public_path__ + "media/images/iconInfo__accent--dark-22e61999db7f7dedb818297e5ed8b455.png";